import { useState } from 'react';
import { Minus } from 'lucide-react';
import FragHans from './FragHans';

/**
 * Persistent floating "Frag Hans" bubble for configurator pages.
 * On mobile: compact avatar-only button, pinned bottom-right, out of the way
 * of the configurator's primary "Weiter" button. On desktop: pill with label.
 */
export default function FragHansFloating({ context = null, initialGreeting = null }) {
  const [open, setOpen] = useState(false);

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        // Mobile: small circular avatar-only, above bottom-nav safe-area.
        // Desktop: pill with label.
        className="fixed z-40 bg-white border border-gray-200 shadow-lg rounded-full hover:shadow-xl transition-all hover:scale-[1.02] group
                   bottom-4 right-4 p-1
                   sm:bottom-6 sm:right-6 sm:pl-1.5 sm:pr-4 sm:py-1.5 sm:flex sm:items-center sm:gap-3"
        data-testid="frag-hans-float-button"
        aria-label="Frag Hans öffnen"
      >
        <span className="relative shrink-0 block">
          <span className="absolute inset-0 rounded-full bg-[#9ec043]/30 animate-ping opacity-75" />
          <img
            src="/avatars/hans-strong.jpg"
            alt="Hans"
            className="relative w-16 h-16 rounded-full object-cover border-2 border-[#9ec043]/50"
          />
        </span>
        <span className="hidden sm:inline text-sm font-medium text-[#32373c] group-hover:text-[#9ec043] transition-colors">Frag HANS</span>
      </button>
    );
  }

  return (
    <div
      className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-40 w-[94vw] sm:w-[380px] h-[560px] max-h-[80vh] bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden flex flex-col"
      data-testid="frag-hans-float-panel"
      role="dialog"
      aria-label="Frag Hans Chat"
    >
      <button
        type="button"
        onClick={() => setOpen(false)}
        className="absolute top-3 right-12 z-10 w-7 h-7 flex items-center justify-center rounded-full hover:bg-gray-100 text-gray-400"
        data-testid="btn-hans-float-minimize"
        title="Minimieren"
        aria-label="Chat minimieren"
      >
        <Minus className="w-4 h-4" />
      </button>
      <FragHans
        variant="floating"
        onClose={() => setOpen(false)}
        context={context}
        initialGreeting={initialGreeting}
      />
    </div>
  );
}
